/**
 * Standings helpers — pure functions extracted from StandingsView so they can
 * be unit-tested (see scripts/test-data-integrity.mjs).
 */

/**
 * parsePosition — Jolpica OMITS `position` entirely for entrants who scored no
 * points in older seasons; Ergast simply never ranked them. It affects 8 driver
 * seasons and 3 constructor seasons between 2000 and 2017.
 *
 * The original fallback was `999 + index`, which rendered those rows with
 * position numbers like 1015, 1016, 1017 — the "scrambled" leaderboard. Return
 * null instead and let the UI show an unranked marker.
 */
export function parsePosition(raw) {
  const n = parseInt(raw, 10);
  return Number.isFinite(n) ? n : null;
}

/**
 * orderStandings — ranked entrants by position ascending, unranked afterwards
 * in the order the API returned them.
 *
 * The table used to render in raw API order on the assumption it was always
 * sorted. Making the ordering explicit means an upstream change can't silently
 * scramble the leaderboard, and it guarantees unranked rows group at the bottom
 * rather than wherever the API happened to put them.
 *
 * Rows must already carry a numeric-or-null `position` (see parsePosition).
 */
export function orderStandings(rows) {
  return rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) => {
      const pa = a.row.position;
      const pb = b.row.position;
      if (pa === null && pb === null) return a.index - b.index;
      if (pa === null) return 1;
      if (pb === null) return -1;
      return pa - pb || a.index - b.index;
    })
    .map(({ row }) => row);
}
